export const MEMBERSHIP_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLScqpkPPTD-aLAzsyInx07IAfIYOUkR4uNalrOBca730jIZ37g/viewform?usp=publish-editor";

export const LEADERSHIP_CONTACTS = [
  { display: "+255 767 087 896", phone: "+255767087896", whatsapp: "255767087896" },
  { display: "+225 782 206 620", phone: "+225782206620", whatsapp: "225782206620" },
];
